import { List } from 'immutable'

import { SIGN_OUT_SUCCESS } from 'modules/auth'
import {
  CREATE_SITE_SUCCESS,
  DELETE_SITE_SUCCESS,
  LOAD_SITES_SUCCESS,
  UPDATE_SITE_SUCCESS,
  NEW_API_KEY_ADDED,
  API_KEY_DELETE,
} from '../action-types'


export default function(state = new List(), {payload, type, ...rest}) {

  switch (type) {
    case CREATE_SITE_SUCCESS:
      return state.unshift(payload)

    case DELETE_SITE_SUCCESS:
      return state.filter(site => site.key !== payload.key)

    case LOAD_SITES_SUCCESS:
      return new List(payload.reverse().map(site => site.set('account', rest.account)))

    case UPDATE_SITE_SUCCESS:
      return state.map(site => site.key === payload.key ? payload.set('account', rest.account) : site)

    case SIGN_OUT_SUCCESS:
      return new List()

    case NEW_API_KEY_ADDED:
      return state.map(site => site.key === payload.siteId ? site.setIn(['apiKeys', payload.key], true) : site);

    case API_KEY_DELETE:
      return state.map(site => site.key === payload.siteId ? site.deleteIn(['apiKeys', payload.key]) : site);

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/sites/reducers/sites.js